goog.provide('el8.util.amplitude.demographicsHelpers');

goog.require('el8.util.amplitude.helpers');

/**
 * Log that the user is attempting to edit insurance.
 *
 * @param {string} editType - if the user clicked replace or view/correct existing
 * @param {boolean} isKareoIntegrated - whether the practice is kareo integrated
 * @param {string} insuranceRank - should only be Primary or Secondary
 */
el8.util.amplitude.logEditInsurance = function (editType, isKareoIntegrated, insuranceRank) {
    var eventName = editType === 'replace' ? 'replace existing' : 'edit existing';
    var ampData = {
        'kareo integration': isKareoIntegrated ? 'yes' : 'no',
        'insurance rank': insuranceRank
    };
    el8.util.amplitude.logEvent(eventName, ampData);
};
